import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientContractComponent } from './components/client-contracts/client-contracts.component';
import { ClientInfoViewComponent } from './components/client-info-view/client-info-view.component';
import { EditClientComponent } from './components/edit-client/edit-client.component';

@NgModule({
  imports: [
    CommonModule,
    ClientContractComponent,
    ClientInfoViewComponent,
    EditClientComponent,
  ],
  exports: [
    ClientContractComponent,
    ClientInfoViewComponent,
    EditClientComponent,
  ],
})
export class LTClientInfoModule { }
